import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const { login, formatApiError } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try { await login(email, password); nav("/"); }
    catch (ex) { setErr(formatApiError(ex)); }
    finally { setBusy(false); }
  };

  return (
    <div className="auth-wrap">
      <form className="auth-card" onSubmit={submit} data-testid="login-form">
        <h1>Welcome back</h1>
        <p className="sub">Sign in to manage inventory and invoices.</p>
        <div className="field" style={{ marginBottom: 14 }}>
          <label>Username</label>
          <input data-testid="login-email" className="input" type="text" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required />
        </div>
        <div className="field" style={{ marginBottom: 14 }}>
          <label>Password</label>
          <input data-testid="login-password" className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        {err && <div className="error-msg" data-testid="login-error" style={{ marginBottom: 14 }}>{err}</div>}
        <button data-testid="login-submit" disabled={busy} type="submit" className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }}>
          {busy ? "Signing in..." : "Sign in"}
        </button>
        <p style={{ marginTop: 18, fontSize: 12, color: "var(--text-muted)", textAlign: "center" }}>
        </p>
      </form>
    </div>
  );
}
